<template>
   <div class="data_div">
    <!-- 标题 -->
    <div class="data_title_box">
        <i class="iconfont icon-dian"></i>
        <span>{{ title }}</span>
    </div>
      <!-- 搜索部分 -->
    <div class="data_right_box">
      <div class="select_left">
        <!-- 关键字 -->
        <div class="search_box">
              <span> 关键字</span>
              <div>
                <el-input class="input_width input_inner" placeholder="请输入搜索关键字" v-model="keywordVal" maxLength="20"></el-input>
              </div>
          </div>

        <!-- 单位选择 -->
        <div class="search_box">
              <span>单位选择</span>
              <div>
                <el-select v-model="companySelVal" placeholder="请选择内容" @change="companyChange" clearable>
                  <el-option v-for="item in companyList"
                             :key="item.id"
                             :label="item.comName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </div>
        </div>

        <!-- 电站选择 -->
        <div class="search_box">
              <span>电站选择</span>
              <div>
                <el-select v-model="stationSelVal" placeholder="请选择内容" @change="stationChange">
                  <el-option v-for="item in stationList"
                             :key="item.id"
                             :label="item.stationName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </div>
        </div>

        <!-- 控制器选择 -->
        <div class="search_box">
              <span>控制器选择</span>
              <div>
                <el-select v-model="controlSelVal" placeholder="请选择内容" @change="controlChange" clearable>
                  <el-option v-for="item in controlList"
                             :key="item.id"
                             :label="item.ctlName"
                             :value="item.id">
                  </el-option>
                </el-select>
              </div>
        </div>

        <!-- 设备类型选择 -->
        <div class="search_box">
              <span>设备类型</span>
              <div>
                <el-select v-model="devTypeSelVal" placeholder="请选择内容" @change="devTypeChange" clearable>
                  <el-option v-for="item in devTypeList"
                             :key="item.infoCode"
                             :label="item.infoName"
                             :value="item.infoCode">
                  </el-option>
                </el-select>
              </div>
        </div>

        <!-- 设备状态 -->
        <div class="search_box">
              <span>设备状态</span>
              <div>
                <el-select v-model="devStateSelval" placeholder="请选择内容" @change="devStateChange" clearable>
                  <el-option v-for="item in devStateList"
                             :key="item.infoCode"
                             :label="item.infoName"
                             :value="item.infoCode">
                  </el-option>
                </el-select>
              </div>
        </div>
      </div>
      <div class="btn_right">
          <button class="button_style0" @click="selectButClick"><i class="iconfont icon-chaxun4"></i>查询</button>
      </div>
    </div>
      <!-- 翻页 -->
      <div class="pagination_div">
        <el-pagination background class="el_pag"
                       @current-change="handleCurrentChange"
                       :current-page="currentPage"
                       :page-size="pageSize"
                       layout="total, prev, pager, next, jumper"
                       :total="pageTotal">
        </el-pagination>
        <div class="function_button_div">
          <button class="button_style1 btn1" @click="addClick"><i class="iconfont icon-tianjia3"></i>添加</button>
          <button class="button_style1 " @click="deleteClick"><i class="iconfont icon-shanchu"></i>删除所有</button>
        </div>
      </div>

      <!-- 数据列表 -->
      <div class="list_box">
        <el-table :data="dataList" class="my_el_table" width="100%" height="100%"  
                  v-loading="loading"  border
                  :cell-style="rowClassName" 
                  :header-cell-style="ListTableHeaderColor"
                  element-loading-text = "加载中，请稍后..."
                  element-loading-background = "#00151b">
          <el-table-column label="ID" prop="id" width="" fixed show-overflow-tooltip></el-table-column>
          <el-table-column label="控制器" prop="controllerStr" fixed width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备名称" prop="devName" width="125" fixed show-overflow-tooltip></el-table-column>
          <el-table-column label="设备码" prop="devCode" width="160" fixed show-overflow-tooltip></el-table-column>
          <el-table-column label="系统类型" prop="sysTypeStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备类型" prop="devTypeStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="电表标记" prop="meterSignStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="上行数据" prop="upDataSignStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="下行数据" prop="downDataSignStr" width="" show-overflow-tooltip></el-table-column>
          <!-- <el-table-column label="告警检测标记" prop="alarmSignStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="变位检测标记" prop="displaceSignStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="越限检测标记" prop="overrunSignStr" width="" show-overflow-tooltip></el-table-column> -->
          <el-table-column label="历史数据存储标记" prop="historySignStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="数据存储表" prop="dtNameStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="点表" prop="ptStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备状态" prop="devStateStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="显示状态" prop="displayStateStr" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="型号id" prop="modelId" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="排序号" prop="sortNumber" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="设备简介" prop="devBrief" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="描述" prop="remark" width="" show-overflow-tooltip></el-table-column>
          <el-table-column label="操作" width="170" fixed="right">
              <template slot-scope="scope">
                <button class="button_style2" @click="detailsClick( scope.row.id)" > 详情 </button>
                <i class="iconfont icon-vertical_line operation_line"></i>
                <button class="button_style2"  @click="editClick( scope.row.id)" > 编辑 </button>
                <i class="iconfont icon-vertical_line operation_line"></i>
                <button class="button_style2" @click="delClick(scope.row.id,scope.row)"> 删除 </button>
              </template>
          </el-table-column>
        </el-table>
      </div>
      
      <!-- 弹窗 -->
      <el-dialog :visible.sync="dialogTableVisible" :append-to-body="true" :lock-scroll="false" :close-on-click-modal="false">
        <div slot="title" class="dialog_title">{{ dialog.title }}</div>
        <div class="dialog_content">
          <el-form :model="dialog.elForm" :rules="dialog.rules" ref="addAlterForm">
            <el-form-item label="电站" prop="statName" label-width="17rem">
              <el-input
                      v-model="dialog.elForm.statName"
                      maxlength="50"
                      placeholder="请输入内容"
                      :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="控制器" prop="controllerId" label-width="17rem">
              <el-select v-model="dialog.elForm.controllerId" placeholder="请选择" >
                  <el-option
                            v-for="item in controlList"
                            :key="item.id"
                            :label="item.ctlName"
                            :value="item.id">
                  </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备名称" prop="devName" label-width="17rem">
              <el-input
                        v-model="dialog.elForm.devName"
                        maxlength="50"
                        placeholder="请输入内容">
              </el-input>
              <span class="remark_span">不超过50个字符</span >
            </el-form-item>
            <el-form-item label="实际名称" prop="actualName" label-width="17rem">
              <el-input
                        v-model="dialog.elForm.actualName"
                        maxlength="50"
                        placeholder="请输入内容">
              </el-input>
              <span class="remark_span">不超过50个字符</span >
            </el-form-item>
            <el-form-item label="设备码" prop="devCode" label-width="17rem">
              <el-input
                        v-model="dialog.elForm.devCode"
                        maxlength="50"
                        placeholder="请输入内容">
              </el-input>
              <span class="remark_span">不超过50个字符</span >
            </el-form-item>
            <el-form-item label="系统类型" prop="sysType" label-width="17rem">
              <el-select v-model="dialog.elForm.sysType" placeholder="请选择内容">
                    <el-option v-for="item in sysTypeList"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型" prop="devType" label-width="17rem">
              <el-select v-model="dialog.elForm.devType" placeholder="请选择内容">
                    <el-option v-for="item in devTypeList"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="电表标记" prop="meterSign" label-width="17rem">
              <el-select v-model="dialog.elForm.meterSign" placeholder="请选择内容">
                    <el-option v-for="item in meterSignList"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据采集间隔" prop="dataInterval" label-width="17rem">
              <el-input
                        v-model="dialog.elForm.dataInterval"
                        type="number"
                        maxlength="20"
                        placeholder="请输入内容">
              </el-input>
              <span class="remark_span">请输入正整数(单位:秒)</span >
            </el-form-item>
            <el-form-item label="上行数据标记" prop="upDataSign" label-width="17rem">
              <el-select v-model="dialog.elForm.upDataSign" placeholder="请选择内容">
                    <el-option v-for="item in upAndDownSign"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="下行数据标记" prop="downDataSign" label-width="17rem">
              <el-select v-model="dialog.elForm.downDataSign" placeholder="请选择内容">
                    <el-option v-for="item in upAndDownSign"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <!-- <el-form-item label="告警检测标记" prop="alarmSign" label-width="17rem">
              <el-select v-model="dialog.elForm.alarmSign" placeholder="请选择内容">
                    <el-option v-for="item in detectionSign"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="变位检测标记" prop="displaceSign" label-width="17rem">
              <el-select v-model="dialog.elForm.displaceSign" placeholder="请选择内容">
                    <el-option v-for="item in detectionSign"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="越限检测标记" prop="overrunSign" label-width="17rem">
              <el-select v-model="dialog.elForm.overrunSign" placeholder="请选择内容">
                    <el-option v-for="item in detectionSign"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item> -->
            <el-form-item label="历史信息存储标记" prop="historySign" label-width="17rem">
              <el-select v-model="dialog.elForm.historySign" placeholder="请选择内容"  @change="historySignChange">
                    <el-option v-for="item in historySignList"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="数据存储表" prop="dtId" label-width="17rem">
              <el-select v-model="dialog.elForm.dtId" placeholder="请选择内容">
                    <el-option v-for="item in hisDataTableList"
                              :key="item.id"
                              :label="item.recordName"
                              :value="item.id">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="点表" prop="ptId" label-width="17rem">
              <el-select v-model="dialog.elForm.ptId" placeholder="请选择内容">
                    <el-option v-for="item in pointTableList"
                              :key="item.id"
                              :label="item.ptName"
                              :value="item.id">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="排序号" prop="sortNumber" label-width="17rem">
              <el-input
                        v-model="dialog.elForm.sortNumber"
                        type="number"
                        maxlength="20"
                        placeholder="请输入内容">
              </el-input>
              <span class="remark_span">请输入大于0的正整数</span >
            </el-form-item>
            <el-form-item label="型号" prop="modelId" label-width="17rem">
              <el-select v-model="dialog.elForm.modelId" placeholder="请选择内容">
                    <el-option v-for="item in modelList"
                              :key="item.id"
                              :label="item.ptName"
                              :value="item.id">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="显示状态" prop="displayState" label-width="17rem">
              <el-select v-model="dialog.elForm.displayState" placeholder="请选择内容">
                    <el-option v-for="item in displayStateList"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备状态" prop="devState" label-width="17rem">
              <el-select v-model="dialog.elForm.devState" placeholder="请选择内容">
                    <el-option v-for="item in devStateList"
                              :key="item.infoCode"
                              :label="item.infoName"
                              :value="item.infoCode">
                    </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备简介" prop="devBrief" label-width="17rem">
              <el-input type="textarea"  v-model="dialog.elForm.devBrief" maxlength="100" placeholder="请输入内容"></el-input>
              <span class="remark_span">不超过100个字符</span>
            </el-form-item>
            <el-form-item label="描述/备注" prop="remark" label-width="17rem">
              <el-input type="textarea"  v-model="dialog.elForm.remark" maxlength="100" placeholder="请输入内容"></el-input>
              <span class="remark_span">不超过100个字符</span>
            </el-form-item>
          </el-form>
          <table class="dialog_table" v-if="dialog.openType === 0">
            <tr>
              <td>添加用户</td>
              <td>{{ dialog.elForm.addUser }}</td>
            </tr>
            <tr>
              <td>添加时间</td>
              <td>{{ longToDate(dialog.elForm.addTime) }}</td>
            </tr>
            <tr>
              <td>最近一次修改用户</td>
              <td>{{ dialog.elForm.alterUser }}</td>
            </tr>
            <tr>
              <td>最近一次修改时间</td>
              <td>{{ longToDate(dialog.elForm.alterTime) }}</td>
            </tr> 
          </table>
        </div>
        <div slot="footer" class="dialog_footer">
            <button class="button_style0" @click="dialogTableVisible=false"><i class="iconfont icon-quxiao1"></i>取消</button>
            <button class="button_style0" v-if="dialog.openType!=0" @click="submitClick('addAlterForm')"><i
                class="iconfont icon-tijiao"></i>保存
            </button>
            <button class="button_style0" @click="resetClick"><i class="iconfont icon-zhongzhi3"></i>重置</button>
        </div>
      </el-dialog>
   </div>
</template>

<script>
import myApi from "@/util/my-api";
import myConst from "@/util/my-const";
import fun from "@/util/util";
export default {
  data(){
    return {
      title: "接入系统/电站->通讯设备管理",
      keywordVal: "",//关键字查询内容
      companyList: [], //单位列表
      companySelVal: "",
      stationListAll:[],
      stationList: [], //电站列表
      stationSelVal: "",
      controlList:[], //控制器列表
      controlSelVal:"",
      devStateList:[], //设备状态列表
      devStateSelval: "",
      devTypeSelVal:"",
      dataList:[],
      currentPage: 1,  //当前页数
      pageSize: 500,  //每页条数
      pageTotal: 0,  //记录总数
      loading:false,
      loadDefault:true, 
      dialogTableVisible:false, //弹出框状态
      sysTypeList:[], //系统类型列表
      devTypeList:[], //设备类型列表
      meterSignList:[], //获取电表标记
      upAndDownSign:[], //上行下行通用标记
      // detectionSign:[],//告警变位越限检测标记列表
      pointTableList:[], //点表列表
      historySignList:[], //历史数据存储标记列表
      hisDataTableList:[], //数据历史储存表列表
      displayStateList:[], //显示状态列表
      modelList:[], //设备型号列表
      comparisonData:{}, //记录查询的单条记录信息
      dialog:{
        title:"",
        openType:0,
        rules:{
          controllerId:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          devName:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          devCode:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          sysType:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          devType:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          meterSign:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          upDataSign:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          downDataSign:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          ptId:[],
          dtId:[],
          displayState:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
          devState:[
            {required: true, message: "请选择内容", trigger: 'change'}
          ],
         
          historySign:[],
         
        },
        elForm:{
          statName:"", //电站名字
          controllerId:"", //控制器id
          devName:"", //设备名称
          actualName:"", //实际名称
          devCode:"", //设备码
          sysType:"",//系统类型码
          devType:"", //设备类型码
          meterSign:"", //电表标记码
          dataInterval:"", //数据采集间隔
          upDataSign:"", //上行数据标记
          downDataSign:"", //下行数据标记
          historySign:"", //历史数据存储标记
          dtId:"", //关联的数据存储表
          ptId:"", //关联的点表
          sortNumber:"", //排序号
          modelId:"", //型号id
          displayState:"", //显示状态
          devState:"", //设备状态
          devBrief:"", //设备简介
          remark:"", //描述备注
        }
      }
    }
  },
  mounted(){
    this.loadCompanyList()
    this.loadStationList()
    this.loadDevTypeList()
    this.loadDevStateList()
  },
  methods: {
     //转化日期格式
     longToDate(val) {
      return fun.longToDate(val);
    },

    //查询单位列表
    loadCompanyList() {
      this.$axios.get(myApi.comGetPermissionCompany).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.companyList = res.data.data;
        } else {
          this.companyList == [];
        }
      });
    },

    //查询电站列表
    loadStationList() {
      this.$axios.get(myApi.getPermissionStation).then((res) => {
        if (res.data.code === myConst.code.success) {
          this.stationListAll = res.data.data
          this.companyChange(); //调用单位选择事件
        } else {
          this.stationListAll = [];
        }
      });
    },
    
    //查询控制器
    loadControl(){
      this.$axios.get(myApi.getControlId + "?staId=" + this.stationSelVal).then(res=>{
        if(res.data.code === myConst.code.success){       
          this.controlList = res.data.data
          if(this.controlList.length > 0){
            if(fun.isNull(this.controlSelVal)){
              this.controlSelVal = ""
            } else {
              this.controlSelVal = this.controlList[0].id
            }    
          } else {
            this.controlSelVal = ""
          }
        } else {
          this.controlList = []
        }
      })
    },

    //查询设备类型码
    loadDevTypeList(){
      // 获取设备类型列表
      this.$axios.get(myApi.getDevType).then(res=>{
        if(res.data.code === myConst.code.success){
          this.devTypeList = res.data.data
        } else {
          this.devTypeList = []
        }
      })
    },

    //查询设备状态列表
    loadDevStateList(){
      this.$axios.get(myApi.getDevState).then(res=>{
        if(res.data.code === myConst.code.success){
          this.devStateList = res.data.data
        } else {
          this.devStateList = []
        }
      })
    },

    //单位选择改变事件
    companyChange() {
      if (fun.isNull(this.companySelVal)) {
        this.stationList = this.stationListAll;
      } else {
        this.stationList = this.stationListAll.filter((x) => 
            x.companyId === this.companySelVal
        );
      }
      if (this.stationList.length > 0) {
        this.stationSelVal = this.stationList[0].id;
        this.loadControl()
        if(this.loadDefault){
          this.loadDevList()
        }   
      } else {
        this.stationSelVal = "";
      }
      if(this.loadDefault){
          this.loadDefault = false
        }
    },

    //电站选择事件
    stationChange(){
      this.loadControl()
     
      
      
    },

    //控制器选择改变事件
    controlChange(){

    },

    //设备类型码选择改变事件
    devTypeChange(){

    },

    //历史数据存储标记选择改变事件
    historySignChange(){
      if(this.dialog.elForm.historySign == 1){
        // this.dialog.rules.ptId = [{required: true, message: "请选择内容", trigger: 'change'}] 
        // this.dialog.rules.dtId = [{required: true, message: "请选择内容", trigger: 'change'}] 
      } else {
        // this.dialog.rules.ptId = [] 
        this.dialog.rules.dtId = [] 
        // this.dialog.elForm.ptId = ''
        this.dialog.elForm.dtId = ''
      }
    },

    //获取弹窗里面的数据
    getDialogData(){
      //获取系统类型码
      this.$axios.get(myApi.getSysType).then(res=>{
        if(res.data.code === myConst.code.success){
          this.sysTypeList = res.data.data
        } else {
          this.sysTypeList = []
        }
      })

      //获取电表标记
      this.$axios.get(myApi.getMeterSign).then(res=>{
        if(res.data.code === myConst.code.success){
          this.meterSignList = res.data.data
        } else {
          this.meterSignList = []
        }
      })

      // 获取上行和下行数据标记
      this.$axios.get(myApi.getDevUpDownDataSign).then(res=>{
        if(res.data.code === myConst.code.success){
          this.upAndDownSign = res.data.data
        } else {
          this.upAndDownSign = []
        }
      })

      //获取点表列表
      let data= {
        stationId: this.stationSelVal,
        devType: this.devType
      }
      this.$axios.post(myApi.getPointTableList ,data).then(res=>{
        if(res.data.code === myConst.code.success){
          this.pointTableList = res.data.data
        } else {
          this.pointTableList  = []
        }
      })

      //获取历史数据存储表标记
      this.$axios.get(myApi.getHistorySign).then(res=>{
        if(res.data.code === myConst.code.success){
          this.historySignList = res.data.data
        } else {
          this.historySignList = []
        }
      })

      // 获取历史存储表
      let params ={
        stationId: this.stationSelVal,
      }
      this.$axios.get(myApi.getDataStorebusGetList, {params}).then(res=>{
        if(res.data.code === myConst.code.success){
          this.hisDataTableList = res.data.data
        } else {
          this.hisDataTableList = []
        }
      })
      
      //获取显示状态
      this.$axios.get(myApi.getDisplaySign).then(res=>{
        if(res.data.code === myConst.code.success){
          this.displayStateList = res.data.data
        } else {
          this.displayStateList = []
        }
      })
    },

    //查询设备列表
    loadDevList(){
      if(fun.isNull(this.stationSelVal)){
        this.$message({ message: "请选择电站", type: "info"})
      } else {
        let data = {
          keyword: this.keywordVal.trim(),
          stationId: this.stationSelVal,
          controllerId: this.controlSelVal,
          devType: this.devTypeSelVal,
          devState: this.devStateSelval,
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
        this.loading=true
      this.$axios.post(myApi.getDevList, data).then(res=>{
        if(res.data.code === myConst.code.success){
          this.loading=false
          this.dataList = res.data.data.list
          this.pageTotal = res.data.data.total
        } else {
          this.loading=false
          this.$message({message:res.data.msg, type: "info"})
          this.dataList = []
          this.pageTotal = 0
        }
      }).catch(()=>{
        this.loading=false
      })
      }
    },

    //根据id查询单条记录
    getOneData(id){
      this.$axios.get(myApi.getOneDataDevInfo + '?id=' + id).then(res=>{
        if(res.data.code === myConst.code.success){
          this.dialog.elForm=res.data.data
          this.dialog.elForm.sysType=this.dialog.elForm.sysType+""
          this.dialog.elForm.devType=this.dialog.elForm.devType ==0?'':this.dialog.elForm.devType+""
          this.dialog.elForm.meterSign=this.dialog.elForm.meterSign+""
          this.dialog.elForm.dataInterval=this.dialog.elForm.dataInterval+""
          this.dialog.elForm.upDataSign=this.dialog.elForm.upDataSign+""
          this.dialog.elForm.downDataSign=this.dialog.elForm.downDataSign+""
          this.dialog.elForm.historySign=this.dialog.elForm.historySign+""
          this.dialog.elForm.modelId=this.dialog.elForm.modelId ==0?'':this.dialog.elForm.modelId+""
          this.dialog.elForm.ptId=this.dialog.elForm.ptId  ==0?'':this.dialog.elForm.ptId
          this.dialog.elForm.dtId=this.dialog.elForm.dtId  ==0?'':this.dialog.elForm.dtId
          this.dialog.elForm.displayState=this.dialog.elForm.displayState+""
          this.dialog.elForm.devState=this.dialog.elForm.devState+""
          let stat = this.stationList.filter((x) => x.id == this.stationSelVal);
          let statName = stat[0].stationName;
          this.dialog.elForm.statName=statName
          this.comparisonData=JSON.parse(JSON.stringify(this.dialog.elForm))
        } else {
          this.$message({message:res.data.msg, type:"info"})
          this.dialog.elForm ={}
        }
      })
    },

    //查询按钮
    selectButClick(){
      this.loadDevList()
    },

    //添加按钮事件
    addClick(){
      this.getDialogData()
      this.resetData()
      this.dialog.title="添加"
      this.dialogTableVisible=true
      this.dialog.openType = 2;
      let stat = this.stationList.filter((x) => x.id == this.stationSelVal);
      let statName = stat[0].stationName;
      this.dialog.elForm.statName=statName
    },

    //删除按钮事件
    deleteClick(){
      this.$confirm("确认要删除该电站下所有的设备吗？", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(()=>{
        this.$axios.post(myApi.deleteDev + '?stationId=' + this.stationSelVal).then(res=>{
          if(res.data.code === myConst.code.success){
            this.$message({message: res.data.data,type: "success"})
            this.loadDevList()
          } else {
            this.$message({message:res.data.msg,type: "info"})
          }
        })
      }).catch(()=>{})
    },

    //设备转态选择事件
    devStateChange(){

    },

    //翻页
    handleCurrentChange(val){
      this.currentPage = val
      this.loadDevList()
    },

    // 详情
    detailsClick(id){
      this.getDialogData()
      this.dialogTableVisible=true
      this.dialog.title='详情'
      this.dialog.openType = 0;
      this.getOneData(id)
    },

    //编辑
    editClick(id){
      this.getDialogData()
      this.dialogTableVisible=true
      this.dialog.title='编辑'
      this.dialog.openType = 1;
      this.getOneData(id)
    },

    // 删除
    delClick(id,val){
      this.$confirm("确认要删除名称为" + val.devName+ "的记录吗？", '提示', {
        confirmButtonText: "确认",
        cancelButtonText: "取消",
      }).then(()=>{
        this.$axios.post(myApi.deleteDev + '?id=' + id).then(res=>{
          if(res.data.code === myConst.code.success){
            this.$message({message: res.data.data,type: "success"})
            this.loadDevList()
          } else {
            this.$message({message:res.data.msg,type: "info"})
          }
        })
      }).catch(()=>{})
    },

    //弹出框提交按钮
    submitClick(formName){
      this.$refs[formName].validate(valid=>{
        if(valid){
          let pt  = this.pointTableList.filter(item=>{
            return item.id == this.dialog.elForm.ptId
          })
          // let ptCode = pt[0].ptCode
          let ptCode = pt.length > 0?pt[0].ptCode:''
          let data= {
            ptCode,
            id: this.dialog.elForm.id,
            stationId: this.stationSelVal,
            devName: this.dialog.elForm.devName,
            controllerId: this.dialog.elForm.controllerId,
            actualName: this.dialog.elForm.actualName,
            devCode: this.dialog.elForm.devCode,
            sysType: this.dialog.elForm.sysType,
            devType: this.dialog.elForm.devType,
            meterSign: this.dialog.elForm.meterSign,
            dataInterval:this.dialog.elForm.dataInterval,
            upDataSign: this.dialog.elForm.upDataSign,
            downDataSign: this.dialog.elForm.downDataSign,
            historySign: this.dialog.elForm.historySign,
            dtId:this.dialog.elForm.dtId,
            ptId: this.dialog.elForm.ptId,
            sortNumber: this.dialog.elForm.sortNumber,
            modelId: this.dialog.elForm.modelId,
            displayState: this.dialog.elForm.displayState,
            devState: this.dialog.elForm.devState,
            devBrief: this.dialog.elForm.devBrief,
            remark: this.dialog.elForm.remark
          }
          console.log(data);
          if(this.dialog.openType === 1){
            let initData=JSON.stringify(this.comparisonData)
            let changeData=JSON.stringify(this.dialog.elForm)
            if(initData == changeData){
              this.$message({message: '您还未作出任何改变!',type: "info",});
            } else {
              this.$confirm("确认保存修改吗？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
              }).then(()=>{
                this.$axios.post(myApi.alterDev, data).then((res) => {
                  if (res.data.code === myConst.code.success) {
                    this.loadDevList(); //修成功重新加载
                    this.$message({message: res.data.data,type: "success",});
                  } else {
                    this.$message({message: res.data.msg,type: "error",});
                  }
                })
              }).catch(()=>{})
            }
          } else if(this.dialog.openType === 2){
            this.$confirm("确认添加该条记录吗？", "提示", {
                confirmButtonText: "确认",
                cancelButtonText: "取消",
            }).then(()=>{
              this.$axios.post(myApi.addDev, data).then(res=>{
                  if(res.data.code === myConst.code.success){
                      this.$message({ message: res.data.data,type: "success"})
                      this.loadDevList()
                  } else {
                      this.$message({ message: res.data.msg,type: "info"})
                  }
              })
            }).catch(()=>{})
          }
        }
      })
    },

    //重置数据
    resetData(){
      return this.dialog.elForm={
        statName:"", //电站名字
          controllerId:"", //控制器id
          devName:"", //设备名称
          actualName:"", //实际名称
          devCode:"", //设备码
          sysType:"1",//系统类型码
          devType:"1", //设备类型码
          meterSign:"0", //电表标记码
          dataInterval:"1", //数据采集间隔
          upDataSign:"0", //上行数据标记
          downDataSign:"0", //下行数据标记
          historySign:"0", //历史数据存储标记
          dtId:"", //关联的数据存储表
          ptId:"", //关联的点表
          sortNumber:"", //排序号
          modelId:"", //型号id
          displayState:"0", //显示状态
          devState:"0", //设备状态
          devBrief:"", //设备简介
          remark:"", //描述备注
      }
    },

    //弹出框重置按钮
    resetClick(){
      if(this.dialog.openType === 2){//如果是添加 则重置数据
        this.resetData()
      } else {
        this.getOneData(this.dialog.elForm.id)
      }
    },

        //设置列表前五列背景颜色
    rowClassName({row,column,rowIndex,columnIndex}){
      if(columnIndex == 0 ||  columnIndex == 2 ){
        return 'background:#022632'
      } else if(columnIndex == 1 || columnIndex == 3 || columnIndex == 18){
        return 'background:#011d28'
      }
    },

     //设置表头前五列背景颜色
     ListTableHeaderColor({row,column,rowIndex,columnIndex}){
       return 'background:#033646'
    },
  }
}
</script>

<style scoped>
@import "~@/assets/css/configInfo.css";
.btn1{
  margin-right: 2rem;
}
::v-deep input::-webkit-outer-spin-button,
::v-deep input::-webkit-inner-spin-button {
  -webkit-appearance: none;
}
::v-deep input[type="number"] {
  -moz-appearance: textfield;
}
</style>